import type { GetReceivablesParams } from './types';

export const receivableKeys = {
  all: ['receivables'] as const,
  lists: () => [...receivableKeys.all, 'list'] as const,
  list: (filters?: GetReceivablesParams) => [...receivableKeys.lists(), filters] as const,
  details: () => [...receivableKeys.all, 'detail'] as const,
  detail: (id: string) => [...receivableKeys.details(), id] as const,
  documents: (receivableId: string) => [...receivableKeys.detail(receivableId), 'documents'] as const,
  taxes: (receivableId: string, search?: string) => [...receivableKeys.detail(receivableId), 'taxes', search] as const,
  taxDocuments: (taxId: string) => [...receivableKeys.all, 'taxes', 'documents', taxId] as const,
};

